import { Fragment } from '@tiptap/pm/model';
import { Decoration_Type } from 'ricos-schema';
import mentionDataDefaults from 'ricos-schema/dist/statics/mention.defaults.json';
import { createRicosMarkExtension } from 'wix-rich-content-plugin-commons';
import { s as styles } from '../mentions-9c714037.js';
import { Suggestion } from './suggestion.js';
import '../style-inject.es-746bb8ed.js';
import '@tiptap/react';
import '@tiptap/suggestion';
import './MentionList.js';
import 'classnames';
import 'prop-types';
import 'react';
import 'ricos-context';
import 'wix-rich-content-common/libs/Tooltip';
import '../MentionAvatar-8eda3416.js';
import 'wix-rich-content-ui-components';
import '../icons/AvatarIcon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const findMention = (editor, char) => {
  var _a;
  const mentionRegex = new RegExp(`(?:^)?${char}[^\\s${char}]*`, "gm");
  const { nodeBefore, pos } = editor.state.selection.$from;
  const { text, nodeSize: nodeBeforeSize } = nodeBefore || {};
  const mention = (_a = text == null ? void 0 : text.match(mentionRegex)) == null ? void 0 : _a[0];
  const mentionIndex = text ? text.search(mentionRegex) : -1;
  if (nodeBeforeSize && mention && mentionIndex !== -1) {
    return { from: pos - nodeBeforeSize + mentionIndex, to: pos };
  }
};
const tiptapExtensions = [
  createRicosMarkExtension({
    type: "mark",
    groups: ["shortcuts-enabled"],
    name: Decoration_Type.MENTION,
    reconfigure: (config, _extensions, _props, settings) => __spreadProps(__spreadValues({}, config), {
      addOptions: () => ({
        settings,
        HTMLAttributes: {},
        renderLabel({ node }) {
          var _a;
          return `${settings.mentionTrigger}${(_a = node.attrs.label) != null ? _a : node.attrs.id}`;
        }
      })
    }),
    createExtensionConfig({ PluginKey }) {
      return {
        name: this.name,
        group: "inline",
        inline: true,
        selectable: false,
        atom: true,
        addAttributes() {
          return mentionDataDefaults.mentionData;
        },
        renderHTML() {
          return ["span", { class: styles.mention }, 0];
        },
        addKeyboardShortcuts() {
          return {
            Backspace: () => this.editor.commands.command(({ dispatch, tr, state }) => {
              let isMention = false;
              const { selection } = state;
              const { empty, anchor } = selection;
              if (!empty) {
                return false;
              }
              state.doc.nodesBetween(anchor - 1, anchor, (node, pos) => {
                if (node.text === this.options.settings.mentionTrigger) {
                  isMention = true;
                  dispatch == null ? void 0 : dispatch(tr.replaceWith(pos, pos + 1, Fragment.empty));
                }
              });
              return isMention;
            })
          };
        },
        addProseMirrorPlugins() {
          return [Suggestion(this.editor, this.options.settings, PluginKey)];
        },
        addCommands() {
          return {
            insertMention: (attributes, pos) => ({ view, tr, editor }) => {
              var _a;
              const nodeAfter = view.state.selection.$to.nodeAfter;
              const overrideSpace = (_a = nodeAfter == null ? void 0 : nodeAfter.text) == null ? void 0 : _a.startsWith(" ");
              const { mentionTrigger } = this.options.settings;
              const range = pos || findMention(editor, mentionTrigger) || {
                from: tr.selection.from,
                to: tr.selection.to
              };
              if (overrideSpace) {
                range.to += 1;
              }
              return editor.chain().focus().insertContentAt(range, [
                {
                  type: "text",
                  text: `${mentionTrigger}${attributes.name}`,
                  marks: [
                    {
                      type: Decoration_Type.MENTION,
                      attrs: {
                        name: attributes.name,
                        slug: attributes.slug,
                        id: attributes.id
                      }
                    }
                  ]
                },
                {
                  type: "text",
                  text: " "
                }
              ]).run();
            }
          };
        }
      };
    }
  })
];

export { tiptapExtensions };
//# sourceMappingURL=tiptap.js.map
